<app-header></app-header>

<section id="sala-prensa" class="bg-grey reset-section-pad2">

    <div class="container">

          <div class="row">
            <app-title-section
                [titleTxt]="salaDePrensaTitle"
            ></app-title-section>   
         </div>

         <div class="row">
             <div class="col-lg-12 sala-prensa-blq">
<!-- 
                    <app-prensa-listing-block class="col-lg-4 col-md-6 col-sm-6 col-12 sala-prensa-blq-inner"
                        *ngFor="let item of salaDePrensaData.prensaBlock_items | reverse; index as i"
                        [prensaBlock_item]="salaDePrensaData.prensaBlock_items[i]"
                    ></app-prensa-listing-block> -->

                    <app-prensa-listing-block class="col-lg-4 col-md-6 col-sm-6 col-12 sala-prensa-blq-inner"
                        *ngFor="let item of orderedsalaDePrensaData; index as i"
                        [prensaBlock_item]="orderedsalaDePrensaData[i]"
                    ></app-prensa-listing-block>

             </div>   

         </div><!-- fin  sala de prensa-->

         <div class="row">
         	<!-- <div class="col-12"><a href="#" class="scroll-down"></a></div> -->
         </div>

     </div>

</section>

<app-footer-main></app-footer-main>
